import { canAccessShiftFloor } from './shiftFloorAccess';

/**
 * Перевіряє чи має користувач доступ до вказаного pathname.
 * Повертає true якщо доступ дозволений.
 */
export function isPathAccessible(pathname, currentUser) {
  const perms = currentUser?.effective_permissions || {};
  // Галочка в Ролях = true. Відсутній або false = немає доступу (і в меню, і за URL).
  const has = (key) => !key || perms[key] === true;
  const isTrue = (key) => perms[key] === true;
  const prod = (sub) => has('menu.production') && has(sub);

  if (pathname === '/login') return true;
  if (pathname === '/') return has('menu.dashboard');
  if (pathname === '/shift-floor') return canAccessShiftFloor(currentUser);
  if (pathname === '/tasks') return isTrue('menu.tasks');

  if (pathname === '/purchase-approvals') {
    return isTrue('menu.purchase_approvals') || has('menu.purchases');
  }

  if (pathname === '/customer-orders' || pathname.startsWith('/customer-orders/')) {
    return has('menu.customer_orders');
  }
  if (pathname === '/customers' || pathname.startsWith('/customers/')) {
    return has('menu.customer_orders');
  }

  if (pathname === '/purchases') return has('menu.purchases');
  if (pathname === '/suppliers' || pathname.startsWith('/suppliers/')) return has('menu.purchases');
  if (pathname === '/supplier-catalog') return has('menu.purchases');

  if (pathname === '/production') return prod('menu.production.planner');
  if (pathname === '/planner-v2') return prod('menu.production.planner');
  if (pathname === '/production-operator') return prod('menu.production.operator');
  if (pathname === '/production-operator-v2') return prod('menu.production.operator');
  if (pathname === '/production-warehouse') return prod('menu.production.warehouse');
  if (pathname === '/production-drying') return prod('menu.production.drying');
  if (pathname === '/production-mixing') return prod('menu.production.mixing');
  if (pathname === '/work-processes') return prod('menu.production.work_processes');
  if (pathname === '/setup') return prod('menu.production.setup');
  if (pathname === '/qc' || pathname === '/qc-kanban') return prod('menu.production.qc_kanban');
  if (pathname === '/qc-stock-page') return prod('menu.production.qc_stock');
  if (pathname === '/maintenance-plan' || pathname === '/maintenance') {
    return prod('menu.production.maintenance');
  }
  if (pathname === '/products' || pathname === '/product-kits') {
    return prod('menu.production.products');
  }
  if (pathname === '/machines') return prod('menu.production.machines');
  if (pathname === '/press-forms') return prod('menu.production.pressforms');
  if (pathname === '/crushing') return has('menu.crushing');
  if (pathname === '/settings-additional-processes') {
    return prod('menu.production.planner');
  }

  if (pathname === '/packaging') return has('menu.packaging');
  if (pathname === '/packaging-daily-norm') return isTrue('menu.packaging_daily_norm');

  // Довідники матеріалів — прив’язані до відповідних складів / розділу складів
  if (pathname === '/raw-materials') return has('menu.stock') && has('menu.stock.raw');
  if (pathname === '/dyes') return has('menu.stock') && has('menu.stock.dyes');
  if (pathname === '/packaging-materials') return has('menu.stock') && has('menu.stock.packaging');
  if (pathname === '/consumable-materials') {
    return has('menu.stock') && has('menu.stock.consumable');
  }
  if (pathname === '/filament') return has('menu.stock');

  // /stock — розділ складів; вкладки фільтруються в StockHubPage
  if (pathname === '/stock' || pathname.startsWith('/stock')) return has('menu.stock');

  if (pathname === '/crm') return isTrue('menu.crm');
  if (pathname === '/learning/make-quiz') return isTrue('menu.learning_new.manage');
  // Ключі ШІ — лише адміністратор ЕРП (керує ролями) з правом керування навчанням
  if (pathname === '/learning/settings') return isTrue('menu.learning_new.manage') && isTrue('menu.settings.roles');
  if (pathname === '/learning' || pathname.startsWith('/learning/')) {
    return isTrue('menu.learning_new') || isTrue('menu.learning_new.manage');
  }

  if (pathname === '/lms/materials' || pathname === '/lms/sync') {
    return isTrue('menu.lms.manage');
  }
  if (pathname === '/lms' || pathname.startsWith('/lms/')) {
    return isTrue('menu.lms') || isTrue('menu.lms.manage');
  }

  if (pathname === '/costing' || pathname.startsWith('/costing/')) {
    return isTrue('menu.costing');
  }
  if (pathname === '/finance' || pathname.startsWith('/finance/')) {
    return isTrue('menu.finance');
  }

  if (pathname === '/leads' || pathname.startsWith('/leads/')) return has('menu.leads');
  if (pathname === '/projects' || pathname.startsWith('/projects/')) return has('menu.projects');
  if (pathname === '/rnd' || pathname.startsWith('/rnd/')) return has('menu.rnd');
  if (pathname === '/oee' || pathname.startsWith('/oee/')) return has('menu.oee');

  if (pathname === '/activity-log') return has('menu.activity_log');
  if (pathname === '/notification-rules') return has('menu.notification_rules');
  if (pathname === '/process-log') return has('menu.process_log');
  if (pathname === '/bulk-edit') return has('menu.bulk_edit');

  if (pathname === '/settings-roles') return has('menu.settings') && has('menu.settings.roles');
  if (pathname === '/settings-staff') return has('menu.settings') && has('menu.settings.staff');
  if (pathname === '/settings-quality') return has('menu.settings') && has('menu.settings.quality');
  if (pathname === '/settings-order-periods') {
    return has('menu.settings') && has('menu.settings.order_periods');
  }
  if (pathname === '/export') return has('menu.settings') && has('menu.export');
  if (pathname === '/import') return has('menu.settings') && has('menu.import');

  // Невідомий маршрут — не відкривати «на всяк випадок»
  return false;
}
